import React, { useState, useEffect, useContext } from "react";
import { NavLink } from "react-router-dom";
import { Button, Paper } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { Link } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import FacebookIcon from "@mui/icons-material/Facebook";

import { FacebookEmbed } from "react-social-media-embed";

import FormDialog from "../modal/modal";
import api from "../../API/api";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";

import { SchoolContex } from "../../Helper/Contex";

const Footer = () => {
  const { courses } = useContext(SchoolContex);

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const [data, setData] = useState({
    name: "",
    email: "",
    phone: "",
    course: "",
  });

  const [load, setLoad] = useState(false);

  const handleInput = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const downloadBrochure = () => {
    if (data.name === "") {
      toast.warn("Please Enter Your Name", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      return;
    }
    if (data.email === "") {
      toast.warn("Please Enter Your Email Id", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      return;
    }
    if (data.phone === "") {
      toast.warn("Please Enter Your Phone No", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      return;
    }
    if (data.course === "") {
      toast.warn("Please Select Any Course", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      return;
    }

    setLoad(true);
    api
      .downloadBrochure(data)
      .then((res) => {
        setLoad(false);
        Swal.fire({
          title: "Success!",
          text: "Thank you! Your download will begin shortly.",
          icon: "success",
          confirmButtonText: "Ok",
        });

        const url = "assets/pdf/PEWSBrochure.pdf";
        const a = document.createElement("a");
        a.href = url;
        a.download = url.split("/").pop();
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((err) => {
        setLoad(false);
        // console.log(err.response);
      });
  };

  const FormBrochure = () => {
    return (
      <>
        <div className="">
          <div className="row">
            <Paper elevation={3}>
              <div className="m-2">
                <div className="m-3 text-center">
                  {" "}
                  <strong> Download Brochure </strong>{" "}
                </div>
                <div className="col-md-12 pb-4">
                  <div>
                    <label htmlFor="">Your Name</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={data.name}
                    onChange={handleInput}
                    id=""
                  />
                </div>
                <div className="col-md-12 pb-4">
                  <div>
                    <label htmlFor="">Email</label>
                  </div>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={data.email}
                    onChange={handleInput}
                    id=""
                  />
                </div>
                <div className="col-md-12 pb-4">
                  <div>
                    <label htmlFor="">Phone No</label>
                  </div>
                  <input
                    type="number"
                    className="form-control"
                    name="phone"
                    value={data.phone}
                    onChange={handleInput}
                    id=""
                  />
                </div>
                <div className="col-md-12 pb-4">
                  <div>
                    <label htmlFor="">Course Interested For</label>
                  </div>
                  <select
                    className="form-control"
                    name="course"
                    onChange={handleInput}
                    value={data.course}
                    id=""
                  >
                    <option value="">-Select-</option>
                    {courses &&
                      courses.map((c) => (
                        <option value={c.courseName}>{c.courseName}</option>
                      ))}
                  </select>
                </div>
                <div className="col-md-12 pb-4 text-center">
                  <Button
                    variant="contained"
                    onClick={downloadBrochure}
                    disabled={load ? true : false}
                  >
                    Download
                  </Button>
                </div>
              </div>
            </Paper>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <ToastContainer />
      <div className="pt-3">
        <div className="bg-light p-1 text-center">
          {/* <Container maxWidth="fullWidth" sx={{ textAlign: 'center' }}> */}
          {/* <Stack direction="row"  alignItems="center" spacing={4}> */}
          <a
            href="https://www.instagram.com/pewsghy/?igshid=YmMyMTA2M2Y%3D"
            target="_blank"
          >
            <InstagramIcon
              fontSize="large"
              sx={{ color: "#E1306C", padding: "5px" }}
            />
          </a>
          <a
            href="https://www.youtube.com/channel/UCpOMWresYXFVxmehptHM98g"
            target="_blank"
          >
            <YouTubeIcon
              fontSize="large"
              sx={{ color: "#FF0000", padding: "5px" }}
            />
          </a>
          <a href="https://www.facebook.com/PEWSGHY/" target="_blank">
            <FacebookIcon
              color="primary"
              fontSize="large"
              sx={{ padding: "5px" }}
            />
          </a>
          {/* </Stack> */}
          {/* </Container> */}
        </div>
        <Paper>
          <section>
            <div className="">
              <div className="row p-0 m-0">
                <div className="col-md-3 ">
                  <div className=" mx-auto m-4 p-3 ">
                    <h6 className="text-uppercase fw-bold mb-4">
                      <CallIcon /> Contact
                    </h6>
                    <small>
                      Purbanchal Educational Welfare Society (PEWS)
                      <br />
                      {/* Administrative Office: R.G. Baruah Road, Opp. Gauhati Commerce College Boy’s Hostel, Guwahati-3 */}
                    </small>
                    <small>
                      College Campus : Amgaon, Bonda Narengi 781026
                      <br />
                      Phone : 88110 99994, 98640 91758, 98640 31785, 98640
                      16245,
                      <br />
                      Email: pewsghy@gmail.com
                    </small>
                  </div>
                </div>
                <div className="col-md-3  footer-box">
                  <div className=" mx-auto m-4 p-3 ">
                    <h6 className="text-uppercase fw-bold mb-4">
                      <Brightness7Icon /> Policies
                    </h6>
                    <>
                      <div>
                        &#10028;{" "}
                        <small>
                          {" "}
                          Policy for fee rebate for students winning laurels
                        </small>
                      </div>

                      <div>
                        &#10028;{" "}
                        <small> Student Grievance Redressal Policy</small>
                      </div>

                      <div>
                        &#10028; <small> Anti Ragging Policy</small>
                      </div>

                      <div>
                        &#10028; <small> Anti-Ragging Committee 2020-21</small>
                      </div>

                      <div>
                        &#10028; <small> Dress code</small>
                      </div>

                      <div>
                        &#10028;{" "}
                        <small> Disciplinary Rules & Regulations</small>
                      </div>

                      <div>
                        &#10028; <small> Cell for Equal Opportunity</small>
                      </div>

                      <div>
                        &#10028; <small> Cell for Gender Sensitization</small>
                      </div>

                      <div>
                        &#10028; <small> ICT Initiatives of MHRD and UGC</small>
                      </div>

                      <div>
                        &#10028;{" "}
                        <small> Mental Health during COVID-19 pandemic</small>
                      </div>
                    </>
                  </div>
                </div>

                <div className="col-md-3  ">
                  <div className=" mx-auto m-4 p-3 ">
                    <h6 className="text-uppercase fw-bold mb-4">
                      <CloudDownloadIcon /> Download Brochure
                    </h6>
                    <p className="">
                      <Button onClick={handleOpen}>
                        <img
                          src="/assets/PEWS-Brochure-cover.png"
                          className="col-12"
                          alt="pews broucher cover"
                        />
                      </Button>
                    </p>
                  </div>
                </div>

                <div className="col-md-3  footer-box">
                  <div className=" mx-auto m-4 p-3 ">
                    <h6 className="text-uppercase fw-bold mb-4">
                      Facebook Page
                    </h6>

                    <div className="service-content">
                      <div
                        className="fb-page"
                        data-href="https://www.facebook.com/PEWSGHY"
                        data-tabs="timeline"
                        data-width="300"
                        data-height="300"
                        data-small-header={true}
                        data-adapt-container-width={true}
                        data-hide-cover={true}
                        data-show-facepile={false}
                      >
                        <blockquote
                          cite="https://www.facebook.com/PEWSGHY"
                          className="fb-xfbml-parse-ignore"
                        >
                          <a href="https://www.facebook.com/PEWSGHY">
                            Purbanchal Educational welfare Society
                          </a>
                        </blockquote>
                      </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <FacebookEmbed url="" className="col-12" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Paper>

        <FormDialog
          form={FormBrochure()}
          open={open}
          handleClose={handleClose}
        />

        <div className="text-center p-2 bg-dark text-white">
          © 2024 Copyright PEWS
        </div>
      </div>
    </>
  );
};

export default Footer;
